<template>
  <div>
    <b-tabs v-model="tabIndex">
      <b-tab title="List View"><list-view v-if="tabIndex === 0"/></b-tab>
      <b-tab title="Matrix View"><matrix-view v-if="tabIndex === 1"/></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ListView from './views/ListView'
import MatrixView from './views/MatrixView'
export default {
  name: 'vip-withdraw-payment-options',
  data () {
    return {
      tabIndex: 0
    }
  },
  components: {
    ListView,
    MatrixView
  }
}
</script>


// WEBPACK FOOTER //
// src/views/payment/viplevelwithdraw/viplevelpayment/VIPLevelPaymentTable.vue